const React = require('react');
const ReactDOMServer = require('react-dom/server');
const chevronDown8 = require('@saks/cxds/platforms/web').ChevronDown8;

function createChevron(element) {
    const props = {}
    const htmlString = ReactDOMServer.renderToString(
        React.createElement(chevronDown8, props)
    );

    const wrapper = document.createElement('div');
    wrapper.innerHTML = htmlString;
    const chevron = wrapper.firstElementChild;

    const hasSvg = element.querySelector('svg')

    if (!hasSvg) {
        element.appendChild(chevron);
    }
}

function createFilterButton(button) {
    if (button.id === 'opensFilter') {
      return;
    }

  if (!button.dataset.refinementListenerAdded) {
    button.addEventListener('click', function () {
      const isCustomRef = button.id.startsWith('custom-ref');
      const id = isCustomRef ? button.id.split('-').pop() : button.id;
      const selector = isCustomRef ? `[aria-controls="refinement-${id.toLowerCase()}"]` : 'button#refinement-' + id;
      const refinementButton = document.querySelector(selector);
      const refinementFieldset = refinementButton && refinementButton.parentElement && refinementButton.parentElement.parentElement;
      if (refinementButton && !refinementFieldset.classList.contains('active')) {
        refinementButton.dispatchEvent(
          new MouseEvent('click', {
            view: window
          })
        );
        refinementButton.click();
      }
    });
    button.dataset.refinementListenerAdded = 'true';
  }
}

const filterSelect = document.querySelector('div.filter-select');

if (filterSelect) {
  createChevron(filterSelect);
}

const filterButton = document.querySelectorAll('#filter-bar-container > div.filter-button-container > button');

if (filterButton.length > 0) {
  filterButton.forEach(button => {
    createChevron(button)
    createFilterButton(button)
  });
}

module.exports = {
    createFilterButton: createFilterButton,
    createChevron: createChevron
}